module.exports = __webpack_public_path__ + "img/da01ae0.jpg";